import AuthComponent from "@components/auth/component";
import DeleteButton from "@components/buttons/DeleteButton";
import EditButton from "@components/buttons/EditButton";
import InfoButton from "@components/buttons/InfoButton";
import { TStockAdjustment } from "@helpers/validation-schemas/warehouse-and-inventory/stock-adjustment.schema";
import { TStockImport } from "@helpers/validation-schemas/warehouse-and-inventory/stock-import.schema";
import { formatDate } from "@utils/general/format-date";

export const stockAdjustmentColumns = (
  editHandler: (id: string | number) => void,
  deleteHandler: (id: string | number) => Promise<void>,
  toggleModalHandler: (adjustment: TStockAdjustment) => void
) => [
  {
    name: "Adjustment ID",
    selector: (row: TStockImport) => row.inventory_adjustment_id || "-",
    sort: true,
  },
  {
    name: "Adjustment Date",
    selector: (row: TStockImport) =>
      formatDate(new Date(row.inventory_adjustment_date)) || "-",
    sort: true,
  },
  {
    name: "Product Code",
    selector: (row: TStockImport) => row.product_code,
    sort: true,
  },
  {
    name: "Product Name",
    selector: (row: TStockImport) => row.product_name,
    sort: true,
  },
  {
    name: "Product Tag",
    selector: (row: TStockImport) => row.product_tag_name,
    sort: true,
  },
  {
    name: "Unit Name",
    selector: (row: TStockImport) =>
      row.unit_name || <div className="italic text-red-500">Need data</div>,
    sort: true,
  },
  {
    name: "Qty",
    selector: (row: TStockImport) => row.qty,
    sort: true,
  },
  {
    name: "Adjustment Method",
    selector: (row: TStockImport) => row.adjustment_method,
    sort: true,
  },
  {
    name: "Allocation Account Name",
    selector: (row: TStockImport) => row.warehouse_name,
    sort: true,
  },
];
